<template>
  <div class="container">
    <div class="img">
      <img src="./img/20.png" alt="" />

    </div>

    <div class="zou"  >
      <div class="han">产业布局</div>
      <div class="ying">
        Industrial
        layout
      </div>
    </div>

    <div class="dao2" >
      <div> <router-link :to="{name:'first'}" >
        <span :class="{active:active=='first'}" @click="active='first'">生物育种</span>
      </router-link></div>
      <div> <router-link :to="{name:'second'}">
        <span :class="{active:active=='second'}" @click="active='second'">生物饲料</span>
      </router-link></div>
        <div> <router-link :to="{name:'third'}">
          <span :class="{active:active=='third'}" @click="active='third'">生物兽药</span>
        </router-link></div>
          <div> <router-link :to="{name:'fourth'}">
            <span :class="{active:active=='fourth'}" @click="active='fourth'">健康养殖</span>
          </router-link></div>
            <div> <router-link :to="{name:'fifth'}">
              <span :class="{active:active=='fifth'}" @click="active='fifth'">产业服务</span>
            </router-link></div>
    </div>
    <div class="xian"></div>

  </div>
</template>

<script>
  export default {
    name: "Index",
    data(){
      return{
        active:''
      }
    },
    watch:{
      $route:{
        deep:true,
        immediate:true,
        handler(newV,olV) {
          console.log(this.active)
          this.active = newV.name;
          console.log(newV,"hello大家好")
          console.log(this.active,"??????")
        }
      }
    }
  }
</script>

<style scoped>
  .img img {
    width: 100%;
  }
  .zou{
    width: 30vw;
    height: 7vh;
    opacity: 0.8;
    background-color: #d7000f;
    position: absolute;
    margin-left: 5.5625vw;
    margin-top: -5.9vh;
  }
  .han{
    font-size: 4.5vw;
    font-family: PingFang SC, PingFang SC-Bold;
    font-weight: 600;
    text-align: left;
    color: #ffffff;
    margin-top:2vw ;
    margin-left: 1.5vw;
  }
  .ying{
    font-size: 3.8vw;
    font-family: PingFang SC, PingFang SC-Light;
    font-weight: 300;
    text-align: left;
    color: #ffffff;
    margin-left: 1.5vw;
    margin-top: 2vw;
  }

  .dao2{
    height:6vw;
    margin-left: 5vw;
    line-height: 6vw;
    display: flex;
    margin-top: 10vw;
  }
  .dao2 div{
    font-size: 4vw;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #949090;
    padding-right: 2vw;
    padding-bottom: 2vw;
  }
  .dao2 div span{
    padding-bottom: 2vw;
    font-size: 4.2vw;
  }
  .xian{
    margin-top: 1.9vw;
    width: 93.0200vw;
    height: 0.0529vw;
    opacity: 0.6;
    background-color: #A2A2A2;
    margin-left: 3.4896vw;

  }
  span:hover{
    color: #d7000f;
    border-bottom: 0.5vw solid #d7000f;
  }

  .active{
    color: #d7000f;
    border-bottom: 0.5vw solid #d7000f;
  }
</style>